import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve, Router } from "@angular/router";
import { Observable } from "rxjs";
import { EventModel } from "../../api/models/event-model";
import { ParsEventService } from "../../pars/pars-event.service";

@Injectable()
export class CurrentEventResolverGuard implements Resolve<any> {

    constructor(private _parsEventService: ParsEventService, private router: Router) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Promise<EventModel | Observable<EventModel> | Promise<EventModel>> {
        return new Promise<EventModel>(async (resolve, reject) => {
            try {
                return resolve(await this._parsEventService.loadCurrentEvent());
            } catch (error) {
                return reject(error);
            }
        });
    }
}